import React from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { useHubspotPipelinesFetch } from 'src/query/settings/integrations/hubspot';

function HubspotFunctionalWrapper(Component) {

  function ComponentWithHooksProp(props) {
    const integration = useSelector(state => _.get(state, "legacyRootReducer.settings.integrations.hubspot.integration"));
    const primaryIntegration = useSelector(state => _.get(state, "legacyRootReducer.settings.integrations.hubspot.integration.primaryIntegration"));
    const integrationId = _.get(primaryIntegration, "id") || _.get(integration, "id");
    const { data, isLoading } = useHubspotPipelinesFetch(integrationId);
    return <Component  {...props}
      hubspotPipelines={data}
      isHubspotPipelinesLoading={isLoading}
    />;
  }
  return ComponentWithHooksProp;
}

export default HubspotFunctionalWrapper;